// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1Hr13","submitted":"Checkbox_submitted__eQaX5","selected":"Checkbox_selected__3PPvq"};